export default {
	"1": {
		"categoria": 'important',
		"es": {
			"titulo": "Error",
			"cuerpo": "Se ha producido un error general"
		},
		"ca": {
			titulo: "Error",
			cuerpo: "S'ha produït un error general"
		}
	},
	"2": {
		"categoria": 'important',
		"es": {
			"titulo": "Error",
			"cuerpo": "Se ha perdido la sesión"
		},
		"ca": {
			titulo: "Error",
			cuerpo: "S'ha perdut la sessió"
		}
	},
	"3": {
		"categoria": 'important',
		"es": {
			"titulo": "Error",
			"cuerpo": "El usuario no es válido"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "L'usuari no és vàlid"
		}
	},
	"4": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No se ha encontrado la oferta"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "No s'ha trobat l'oferta"
		}
	},
	"6": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La oferta va dirigida a empleo"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "L'oferta s'adreça a ocupació"
		}
	},
	"7": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La oferta va dirigida a prácticas"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "L'oferta s'adreça a pràctiques"
		}
	},
	"8": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El dato existía previamente"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "La dada existia prèviament"
		}
	},
	"9": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El usuario se encuentra bloqueado"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "L'usuari es troba blocat"
		}
	},
	"10": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Ya es candidato/a a la oferta"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "Ja sou candidat/a a l'oferta"
		}
	},
	"11": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Falta documentación necesaria"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "Falta documentació necessària"
		}
	},
	"12": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Se ha producido un error enviando el email"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "S'ha produït un error a l'hora d'enviar el correu"
		}
	},
	"13": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No puede gestionar la oferta"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "No podeu gestionar l'oferta"
		}
	},
	"14": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No puede pasar al estado seleccionado desde el actual"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "No podeu passar a l'estat seleccionat des de l'actual"
		}
	},
	"15": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Faltan datos obligatorios"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "Falten dades obligatòries"
		}
	},
	"16": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Hay otro usuario con ese ID"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "Hi ha un altre usuari amb aquest ID"
		}
	},
	"17": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No puede inscribirse a la oferta porque se solapa con su práctica"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "No podeu inscriure-us a l'oferta perquè coincideix amb les pràctiques"
		}
	},
	"18": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No puede inscribirse a la oferta, es para estudiantes de grado"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "No podeu inscriure-us a l'oferta, és per a estudiants de grau"
		}
	},
	"19": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No puede inscribirse a la oferta, es para estudiantes de postgrado"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "No podeu inscriure-us a l'oferta, és per a estudiants de postgrau"
		}
	},
	"20": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No tiene servicio de empleo"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "No té servei d'ocupació"
		}
	},
	"21": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No tiene servicio de prácticas"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "No té servei de pràctiques"
		}
	},
	"22": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No está identificado como UTP ni como UTE"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "No estau identificat com a UTP ni com a UTE"
		}
	},
	"23": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No apareces matriculado de prácticas ponte en contacto con nosotros para solucionarlo"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "No apareixeu matriculat de pràctiques, posau-vos en contacte amb nosaltres per solucionar-ho"
		}
	},
	"24": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Hay un problema con su empresa. Póngase en contacto con el administrador"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "Hi ha un problema amb la vostra empresa. Posau-vos en contacte amb l'administrador"
		}
	},
	"25": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La oferta ya tienen un gestor asociado y no puede editarse, póngase en contacto con él"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "L'oferta ja té un gestor/a associat i no pot editar-se. Posau-vos en contacte amb ell/a."
		}
	},
	"26": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No se han encontrado estudios asociados a tu perfil. Por favor acude a secretaría de alumnos/as para actualizar tu información"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "No s'han trobat estudis associats al vostre perfil. Si us plau, acudiu a secretaria d'alumnes per actualitzar la vostra informació"
		}
	},
	"27": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "Por favor revisa los Datos de la Práctica, la fecha de inicio debe ser anterior a la fecha de finalización de las prácticas."
		},
		"ca": {
			titulo : "Error",
			cuerpo : "Si us plau, revisau les dades de les pràctiques. La data d'inici ha de ser anterior a la data de finalització de les pràctiques."
		}
	},
	"28": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La contraseña no es segura"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "La contrasenya no és segura."
		}
	},
	"29": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Ya hay un contacto registrado en la empresa con este email"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "Ja hi ha un contacte registrat a l'empresa amb aquesta adreça"
		}
	},
	"30": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La candidatura ya ha sido tramitada, no puedes desinscribirte"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "La candidatura ja ha estat tramitada, no podeu desinscriure-us-hi"
		}
	},
	"31": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No se encuentra la candidatura"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "No es troba la candidatura"
		}
	},
	"32": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Lo sentimos, estás dado de baja del servicio y no puedes inscribirte a ofertas"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "Ens sap greu, estau donat de baixa del servei i no podeu inscriure-us a ofertes"
		}
	},
	"33": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El cif no tiene formato correcto"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "El CIF no té el format correcte"
		}
	},
	"34": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El permiso de trabajo es obligatorio para usuarios con nacionalidad distinta a los 28 países de la Unión Europea"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "El permís de treball és obligatori per a usuaris amb nacionalitat diferent de la dels 28 països de la Unió Europea"
		}
	},
	"35": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La encuesta no es accesible.",
			"to": '/'
		},
		"ca": {
			titulo : "Error",
			cuerpo : "L'enquesta no és accessible.",
		}
	},
	"36": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La encuesta no es para usuarios existentes.",
			"to": '/'
		},
		"ca": {
			titulo : "Error",
			cuerpo : "L'enquesta no és per a usuaris existents",
			"to": '/'
		}
	},
	"37": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La encuesta no permite acceso anónimo. Intentan entrar como anonimo pero no se puede.",
			"to": '/'
		},
		"ca": {
			titulo : "Error",
			cuerpo : "La encuesta no permite acceso anónimo. Intentan entrar como anonimo pero no se puede.",
			to : '/'
		}
	},
	"38": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": " Atención. La encuesta a la que estás tratando de acceder ya no está disponible para tu perfil. No estas en el target de la encuesta.",
			"to": '/'
		},
		"ca": {
			titulo : "Error",
			cuerpo : "Atenció. L'enquesta a la qual intentau accedir ja no està disponible per al vostre perfil. No sou al target de l'enquesta.",
			to : '/'
		}

	},
	"39": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Ya has contestado esta encuesta",
			"to": '/'
		},
		"ca": {
			titulo : "Error",
			cuerpo : "Ja heu contestat aquesta enquesta",
			to : '/'
		}
	},
	"40": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Faltan preguntas por contestar"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "Falten preguntes per contestar"
		}
	},
	"42": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El enlace está caducado o ya ha sido utilizado"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "L'enllaç està caducat o ja ha estat utilitzat"
		}
	},
	"41": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No se encuentran los estudios de la titulación indicada"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "No es troben els estudis de la titulació indicada"
		}
	},
	"44": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El email indicado pertenece a otra empresa, indique otro."
		},
		"ca": {
			titulo : "Error",
			cuerpo : "L'adreça electrònica indicada pertany a una altra empresa. Facilitau-ne una altra."
		}
	},
	"46": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La extensión del archivo no esta permitida"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "L'extensió de l'arxiu no està permesa"
		}
	},
	"48": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "La operación no está permitida"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "L'operació no està permesa"
		}
	},
	"49": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "Esta práctica no puede cambiar de estado"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "Aquesta pràctica no pot canviar d'estat"
		}
	},
	"50": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "El usuario con el que te has logado no tiene permitido el acceso al Portal de Tutores, por favor, contacta con nosotros para habilitar el acceso"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "L'usuari amb qui t'has aconseguit no té permès l'accés al Portal de Tutors, si us plau, contacta amb nosaltres per habilitar l'accés"
		}
	},
	"66": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "El Documento de Identidad no tiene formato válido"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "El document d'identitat no té un format vàlid"
		}
	},
	"500": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El servicio actualmente no esta disponible"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "El servei actualment no està disponible"
		}
	},
	"501": {
		"categoria": 'medium',
		"es": {
			"details": "Practica que pasa de pendiente de evaluar a evaluada",
			"titulo": "Enhorabuena",
			"cuerpo": "La práctica ha sido marcada como evaluada correctamente",
			"to": "/tutorados/en-evaluacion"
		},
		"ca": {
			details : "Pràctica que passa de pendent d'avaluar a avaluada",
			titulo : "Enhorabona",
			cuerpo : "La pràctica ha estat marcada com a avaluada correctament",
			to : "/tutorats/en-avaluació"
		}
	},
	"502": {
		"categoria": 'medium',
		"es": {
			"details": "Practica se valida o se rechaza",
			"titulo": "Enhorabuena",
			"cuerpo": "Estado cambiado correctamente",
			"to": "/validaciones/pendientes"
		},
		"ca": {
			details : "La pràctica es valida o es rebutja",
			titulo : "Enhorabona",
			cuerpo : "Estat canviat correctament",
			to : "/validacions/pendents"
		}
	},
	"503": {
		"categoria": 'medium',
		"es": {
			"details": "Practica que pasa de evaluada a pendiente de evaluar",
			"titulo": "Enhorabuena",
			"cuerpo": "La práctica ha sido marcada como pendiente de evaluar correctamente",
			"to": "/tutorados/evaluados"
		},
		"ca": {
			details : "Pràctica que passa d'avaluada a pendent d'avaluar",
			titulo : "Enhorabona",
			cuerpo : "La pràctica ha estat marcada com a pendent d'avaluar correctament",
			to : "/tutorats/avaluats"
		}
	},
	"504": {
		"categoria": 'medium',
		"es": {
			"titulo": "Enhorabuena",
			"cuerpo": "Se ha enviado a tu email un correo para reestablecer tu contraseña",
			"to": "/login"
		},
		"ca": {
			titulo : "Enhorabona",
			cuerpo : "S'ha enviat al vostre correu un missatge per restablir la contrasenya",
			to : "/login"
		}
	},
	"505": {
		"categoria": 'medium',
		"es": {
			"titulo": "Enhorabuena",
			"cuerpo": "Tu contraseña ha sido restablecida",
			"to": "/login"
		},
		"ca": {
			titulo : "Enhorabona",
			cuerpo : "S'ha restablert la contrasenya",
			to : "/login"
		}
	},
	"506": {
		"categoria": 'medium',
		"es": {
			"titulo": "Enhorabuena",
			"cuerpo": "La oferta ha sido actualizada correctamente",
		},
		"ca": {
			titulo : "Enhorabona",
			cuerpo : "L'oferta ha estat actualitzada correctament",
		}
	},
	"116": {
		"categoria": 'medium',
		"es": {
			"titulo": "Lo sentimos",
			"cuerpo": "No se puede descargar certificado porque no has tutorizado ninguna práctica en el año académico seleccionado.",
		},
		"ca": {
			titulo : "Ho sentim",
			cuerpo : "No es pot descarregar certificat perquè no has tutoritzat cap pràctica a l'any acadèmic seleccioneu.",
		}
	},
	"115": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "Año académico no válido.",
		},
		"ca": {
			titulo : "Error",
			cuerpo : "L'any acadèmic no és vàlid."
		}
	},


}



// WEBPACK FOOTER //
// ./src/errors/index.js